import React from 'react';
import { EditView, Field } from '@builtbypixel/nucleus';
import { Container, Box } from '@chakra-ui/react';

import setup from './setup';

// View-only: subscriptions are a record of marketing consent, so every field is
// disabled. Admins list, search, export and delete from the List view.
const EditForm = () => {
  return (
    <EditView setup={setup} isFullWidth={false}>
      <Container
        p={{ base: '10px', sm: '15px' }}
        w='100%'
        variant='card'
        rounded='none'
        maxWidth='none'
      >
        <Box display='flex' flexDir='row' gridGap='3'>
          <Field
            auto
            isFullWidth
            name='email'
            label='Email Address'
            component='text'
            disabled
          />
          <Field
            auto
            isFullWidth
            name='source'
            label='Source'
            component='text'
            disabled
          />
        </Box>
        <Box display='flex' flexDir='row' gridGap='3'>
          <Field
            auto
            isFullWidth
            name='consented_at.date'
            label='Consent Given'
            component='text'
            disabled
          />
          <Field
            auto
            isFullWidth
            name='ip_address'
            label='IP Address'
            component='text'
            disabled
          />
        </Box>
      </Container>
    </EditView>
  );
};

export default EditForm;
